module.exports = __webpack_public_path__ + "c68c4e3b5086809db9829c0eb21324a0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg24.jpeg
// module id = 33
// module chunks = 0